import { HateoasResource } from '@lagoshny/ngx-hateoas-client';
import { BaseServicePolicy } from './base-service-policy';

@HateoasResource('app-wans')
export class AppWanV2 extends BaseServicePolicy {
    endpointAttributes: string[];
    selected = false;
}
